module.exports = __webpack_public_path__ + "static/1-72886542b5cc40b8859159c8375c561f.jpg";